// Only One prefix uppercase is indeed,
// for match the routing lazy loading file.

const MUZIK_LISTEN = process.env.VUE_APP_MUZIK_LISTEN
const MUZIK_READ = process.env.VUE_APP_MUZIK_READ
const MUZIK_CONCERT = process.env.VUE_APP_MUZIK_CONCERT
// const MUZIK_CSS = process.env.VUE_APP_MUZIK_CSS
const MUZIK_AIR = process.env.VUE_APP_MUZIK_AIR
const DEFAULT_PRODUCTION = process.env.VUE_APP_MUZIK_DEFAULT
const DOMAIN = process.env.VUE_APP_MUZIK_DOMAIN

export const PRODUCTION_LIST = [
  MUZIK_LISTEN,
  MUZIK_READ,
  MUZIK_CONCERT,
  // MUZIK_CSS,
  MUZIK_AIR
]

export function checkProduction() {
  let PRODUCTION_MAP = {}
  PRODUCTION_MAP[MUZIK_LISTEN] = 'LISTEN'
  PRODUCTION_MAP[MUZIK_READ] = 'READ'
  PRODUCTION_MAP[MUZIK_CONCERT] = 'CONCERT'
  // PRODUCTION_MAP[MUZIK_CSS] = 'LISTEN'
  PRODUCTION_MAP[MUZIK_AIR] = 'AIR'

  const subDomain = window.location.host.split('.')[0].toUpperCase()
  const subPath = window.location.pathname.split('/').length > 2
    ? window.location.pathname.split('/')[2].toUpperCase()
    : ''
  const domain = DOMAIN.split('.')[0].toUpperCase()
  const production = PRODUCTION_LIST.find(product => {
    return product.toUpperCase() === subDomain ||
    product.toUpperCase() === subPath ||
    product.toUpperCase() === `stage-${subDomain}-v` || // for development
    product.toUpperCase() === `${subDomain}-v` // for development
  })

  if (subDomain === domain || DEFAULT_PRODUCTION === '') { // for AIR
    return PRODUCTION_MAP[MUZIK_AIR]
  }

  if (production) {
    return PRODUCTION_MAP[production]
  } else {
    return DEFAULT_PRODUCTION
  }
}
